<template>
  <div>
    <div class="input-container">
      <input type="text" v-model="filterString" />
      <div class="fa fa-search" />
    </div>
    <label>Insert Placeholders</label>
    <div class="placeholder-buttons px-1">
      <transition-group name="slide-down">
        <div v-for="placeholder in filteredPlaceholders" :key="placeholder">
          <div class="placeholder-btn" @click="$emit('pick', placeholder)">
            <div class="fa fa-plus" />
            &thinsp;
            {{ placeholder.replace(/_/g, ' ') }}
          </div>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    filteredPlaceholders() {
      if (this.filterString.length === 0) {
        return this.placeholders
      }
      return this.placeholders.filter((x) =>
        x.toLowerCase().includes(this.filterString)
      )
    },
  },
  data() {
    return {
      filterString: '',
    }
  },
  props: ['placeholders'],
}
</script>

<style scoped>
.placeholder-btn {
  background-color: #f9890e;
  color: white;
  margin: 3px 0;
  width: 100%;
  cursor: pointer;
  padding: 5px;
}

.input-container {
  position: relative;
}

.input-container input {
  height: auto;
  padding-right: 5px;
}

.input-container .fa {
  position: absolute;
  top: 0;
  right: 5px;
  color: rgba(0, 0, 0, 0.54);
}
</style>
